import { Days } from '@e3dc-react/shell/Libs/date/types'
import { WeekDays } from '../../installation/forms'

export const transformWeekdaysToAbbreviated = (weekdays: WeekDays): Days => {
  return {
    mo: weekdays.monday,
    tu: weekdays.tuesday,
    we: weekdays.wednesday,
    th: weekdays.thursday,
    fr: weekdays.friday,
    sa: weekdays.saturday,
    su: weekdays.sunday,
  }
}

export const transformAbbreviatedToWeekdays = (days: Partial<Days>): Partial<WeekDays> => {
  return {
    monday: days.mo,
    tuesday: days.tu,
    wednesday: days.we,
    thursday: days.th,
    friday: days.fr,
    saturday: days.sa,
    sunday: days.su,
  }
}
